
import React from 'react';
import { Button } from 'react-bootstrap';
import { axiosInstance } from '../api/Axios';

const DownloadInvoicePDF = ({ invoiceId }) => {
  const handleDownload = async () => {
    try {
      const url = `api/financial/export-pdf/${invoiceId}/invoice/`;
      const response = await axiosInstance.get(url, {
        responseType: 'blob'
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', `factura_${invoiceId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      alert('Error al descargar el PDF.');
      console.error('PDF download error:', error);
    }
  };

  return (
    <Button variant="outline-primary" onClick={handleDownload}>
      Descargar PDF
    </Button>
  );
};

export default DownloadInvoicePDF;
